import { DetailsList, IconButton, PanelType, Stack, Text } from 'office-ui-fabric-react';
import { SelectionMode } from 'office-ui-fabric-react/lib/Utilities';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { Data } from '../../../data/Data';
import { DataDocumentReservation } from '../../../data/DataDocumentReservation';
import { DataDocument_ReservationEcheancierStade } from '../../../data/DataDocument_ReservationEcheancierStade';
import { Immocom } from '../../../specifique/immocom';
import { EUIPanel } from '../../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../../Outils/MessageBars';

export class PanelExportDocuments extends Component {

    static defaultProps = {
        forceUpdate: undefined, // Permet de forcer le rechargement (en particulier après publipostage)
        idOperation: undefined,
        /* --- */
        onDismiss: () => null,
    };

    static defaultState = {
        documents: [],
    };

    constructor(props) {
        super(props);
        this.state = { ...PanelExportDocuments.defaultState };
    };

    _chargementDonnees = () => {
        const { idOperation } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des documents en cours..."
        });

        const filtres = { idOperation, inclureFileData: false };
        const promises = [
            DataDocument_ReservationEcheancierStade._chargementDocument_ReservationEcheancierStadesLesPlusRecents(filtres),
            DataDocumentReservation._chargementDocument_ReservationsLesPlusRecents(filtres)
        ];
        Promise.all(promises).then(responses => {
            let documents = [];
            responses.forEach(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null)
                    documents = documents.concat(responseFetch.reponseAPIobjet || []);
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    return;
                }
            })
            documents = documents.sort((a, b) => new Date(b.creerLe) - new Date(a.creerLe));
            const state = { ...PanelExportDocuments.defaultState, documents };
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
        });
    };

    _telecharger = (rowGUID) => () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des documents en cours..."
        });

        Data._chargementDocument(rowGUID)
            .then((responseFetch) => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const document = responseFetch.reponseAPIobjet || {};
                    const fichier = Scriba.fichier().Base64VersByteArray(document.fileData || []);
                    Scriba.fichier().EnregisterSous(fichier, document.nom);
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onEnregistrement);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
    }

    componentDidMount = () => {
        const { idOperation } = this.props;
        if (!!idOperation) this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { forceUpdate, idOperation } = this.props;
        if (!!idOperation)
            if (idOperation !== prevProps.idOperation || forceUpdate !== prevProps.forceUpdate)
                this._chargementDonnees();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { documents } = this.state;

        return <EUIPanel
            headerText="Documents"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            type={PanelType.medium}
        >

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                infoMessage={this.state.messageMessageBarFiltres}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {!!documents && Array.isArray(documents) && documents.length > 0 &&
                <DetailsList
                    columns={[
                        {
                            fieldName: "nom",
                            isMultiline: true,
                            isResizable: true,
                            key: "nom",
                            name: "Document",
                        },
                        {
                            fieldName: "typeDocument",
                            isResizable: true,
                            key: "typeDocument",
                            name: "Type",
                        },
                        {
                            isResizable: true,
                            key: "creerLe",
                            name: "Créé le",
                            onRender: (item) => <span>{Scriba.date().stringDateHeureFormatCourt(item.creerLe)}</span>
                        },
                        {
                            iconName: null,
                            isIconOnly: true,
                            key: "download",
                            minWidth: 20,
                            maxWidth: 20,
                            onRender: (item) => {
                                return <IconButton
                                    iconProps={{ iconName: "Download" }}
                                    onClick={this._telecharger(item.rowGUID)}
                                    title="Télécharger"
                                />;
                            }
                        }
                    ]}
                    items={documents}
                    selectionMode={SelectionMode.none}
                />
            }

        </EUIPanel>;

    };

};